// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__EBAr6","modal":"Modal_modal__3v99N","fadeIn":"Modal_fadeIn__g1JCA","actions":"Modal_actions__8EBrW","cancel":"Modal_cancel__tRjj9"};